import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SettlementLoanFunding } from 'views/orders/settlement/components/settlement-loan-funding';
import { NewOrderType } from 'types/order';

type LoanFundingTableProps = {
  order: NewOrderType;
};

export const LoanFundingTable: FC<LoanFundingTableProps> = ({ order }) => {
  const { t } = useTranslation('closingDisclosure');

  if (!order.accounting || order.accounting.length === 0) {
    return null;
  }

  return (
    <SettlementLoanFunding
      accounting={order.accounting}
      t={t}
    />
  );
};
